import React, { useEffect, useMemo, useState } from 'react';
import { MdOutlineCancel, MdOutlineDeleteForever } from 'react-icons/md';
import { BiCheckCircle, BiEditAlt } from 'react-icons/bi';
import {
    customWarnOption,
    deletedWarnOption,
    savedStatusOption,
} from 'helpers/alertLabel';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import EditableCell from 'components/Table/EditableCell';
import Button from 'components/Button/Button';
import { SingleValue } from 'react-select';
import { Option } from 'components/SelectInput/BasicSelectInput';
import { getList } from 'features/master/poleType/poleType.reducer';
import { RootState } from 'app/store';
import SelectInput from 'components/SelectInput/SelectInput';
import * as XLSX from 'xlsx';

import { getList as getPoleStatusList } from 'features/master/poleStatus/poleStatus.reducer';
import { isArrayEmpty } from 'helpers/checkEmptiness';
import { HttpClientError, RequestStatus } from 'http-client';
import { Checkbox, Dropdown } from 'flowbite-react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import DefaultModal from 'components/Modal/DefaultModal';
import Places from './Places';
import { AiOutlineMenu } from 'react-icons/ai';
import {
    changeStatusMultiplePole,
    createPole,
    deleteMultiplePole,
    deletePole,
    getPoleByJob,
    reset,
    updatePole,
} from '../../../../basic/pole/pole.reducer';
import PoleApi from '../../../../basic/pole/pole.api';
import { LocationCoordinate, Pole } from '../../../../basic/pole/models';
import TableWithServerPaging from '../../../../../components/Table/TableWithServerPaging';
import { checkRoleActionAccess } from '../../../../../routes/checkRoleAccess';
import { ActionEnum, MenuEnum } from '../../../../../routes/models';
import { UserCredential } from '../../../../login/models';
import { useSelected } from '../../../../../hooks/checkbox/useSelected';
import { useShiftSelected } from '../../../../../hooks/checkbox/useShiftSelected';
import { useParams } from 'react-router-dom';
import { SortingEnum } from '../../../../approval/models';
import { Job } from '../../../process/job/models';
import { getSingle } from '../../../process/job/job.reducer';
import { RiSearchLine } from 'react-icons/ri';
import { FiFilter, FiRefreshCw, FiUpload } from 'react-icons/fi';
import { HiCheck } from 'react-icons/hi';
import JobPrepExcelPanel from './JobPrepExcelPanel';
import ViewMaps from './ViewMaps';
import JobPrepSummaryCards from './JobPrepSummaryCards';
import moment from 'moment';
import { getGeocode } from 'use-places-autocomplete';
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import { useLoadScript } from '@react-google-maps/api';
const JobPrepTable = () => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);
    const { id } = useParams();

    const libraries: Libraries = ['places'];
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: 'AIzaSyDQ-aesOz_ut1yBv_d6FG-0N60uqDwgLZs',
        libraries: libraries,
    });

    const handleSetPoleAddress = async (row: any) => {
        const { index, original } = row;
        const lat = original.latitude;
        const lng = original.longitude;

        if (!lat || !lng) {
            MySwal.fire({
                icon: 'warning',
                title: 'No Coordinate',
                text: 'Please set latitude and longitude first.',
            });
            return;
        }
        try {
            const results = await getGeocode({ location: { lat, lng } });
            if (results && results.length > 0) {
                const address = results[0].formatted_address;
                updateMyData(index, 'address', address);

                let _input = {
                    job_id: original.job_id,
                    seq: original.seq ?? '',
                    no: original.no,
                    address: address,
                    is_pip: original.is_pip ?? 0,
                    latitude: original.latitude,
                    longitude: original.longitude,
                    type_id: original.type_id,
                    is_fielding: original.is_fielding,
                    is_mre: original.is_mre,
                    is_katapult: original.is_katapult,
                    notes: original.notes,
                    index: original.index ?? 0,
                };
                let sendData = {
                    ..._input,
                    id: original.id,
                    employee_prep_id: original.employee_prep_id ?? '',
                    employee_calcspec_id: original.employee_calcspec_id ?? '',
                    employee_qc_id: original.employee_qc_id ?? '',
                    employee_katapult_id: original.employee_katapult_id ?? '',
                };
                dispatch(updatePole(sendData));
            } else {
                MySwal.fire({
                    icon: 'warning',
                    title: 'Not Found',
                    text: 'Address not found for the given coordinates.',
                });
            }
        } catch (error) {
            console.error('Geocoding error:', error);
            MySwal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to retrieve address.',
            });
        }
    };

    const handleSetMultiplePoleAddress = async () => {
        if (isArrayEmpty(allSelectedIds)) return;

        const selectedPoles = rowData.filter((pole) =>
            allSelectedIds.includes(pole.id),
        );
        const polesWithoutCoords = selectedPoles.filter(
            (p) => !p.latitude || !p.longitude,
        );

        if (polesWithoutCoords.length > 0) {
            MySwal.fire({
                icon: 'warning',
                title: 'No Coordinate',
                text: 'Some selected poles are missing latitude and longitude. Please set them first.',
            });
            return;
        }

        setIsSettingBatchAddress(true);
        let successCount = 0;
        let failCount = 0;

        for (const original of selectedPoles) {
            const lat = original.latitude;
            const lng = original.longitude;
            const originalIndexInRowData = rowData.findIndex(
                (r) => r.id === original.id,
            );

            try {
                const results = await getGeocode({ location: { lat, lng } });
                if (results && results.length > 0) {
                    const address = results[0].formatted_address;
                    updateMyData(originalIndexInRowData, 'address', address);

                    let _input = {
                        job_id: original.job_id,
                        seq: original.seq ?? '',
                        no: original.no,
                        address: address,
                        is_pip: original.is_pip ?? 0,
                        latitude: original.latitude,
                        longitude: original.longitude,
                        type_id: original.type_id,
                        is_fielding: original.is_fielding,
                        is_mre: original.is_mre,
                        is_katapult: original.is_katapult,
                        notes: original.notes,
                        index: original.index ?? 0,
                    };
                    let sendData = {
                        ..._input,
                        id: original.id,
                        employee_prep_id: original.employee_prep_id ?? '',
                        employee_calcspec_id:
                            original.employee_calcspec_id ?? '',
                        employee_qc_id: original.employee_qc_id ?? '',
                        employee_katapult_id:
                            original.employee_katapult_id ?? '',
                    };
                    dispatch(updatePole(sendData));
                    successCount++;
                } else {
                    failCount++;
                }
            } catch (error) {
                console.error('Geocoding error for pole', original.no, error);
                failCount++;
            }
        }
        dispatch(reset());
        setIsSettingBatchAddress(false);

        MySwal.fire({
            icon: failCount === 0 ? 'success' : 'warning',
            title: 'Batch Update Address',
            text: `Successfully updated ${successCount} address(es). Failed: ${failCount}`,
        });

        if (successCount > 0) {
            handleClearSelection();
        }
    };

    const [rowData, setRowData] = useState<Pole[]>([]);
    const [pageCount, setPageCount] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selectAll, setSelectAll] = useState<boolean>(false);
    const [isAddNewActive, setIsAddNewActive] = useState<boolean>(false);
    const [isMapEditable, setIsMapEditable] = useState<boolean>(false);
    // shift purpose only
    const [initialPoleIds, setInitialPoleIds] = useState<Array<string>>([]);

    const [showExcelPanel, setShowExcelPanel] = useState<boolean>(true);
    const [showMaps, setShowMaps] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [isExportingKML, setIsExportingKML] = useState(false);
    const [isSettingBatchAddress, setIsSettingBatchAddress] = useState(false);
    const [summaryData, setSummaryData] = useState({
        totalPole: 0,
        poleA: 0,
        poleB: 0,
        poleC: 0,
    });

    const user = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential),
    );
    const poleTypeOptions = useAppSelector(
        (state: RootState) => state.poleType.options ?? [],
    );
    const pole = useAppSelector(
        (state: RootState) => state.pole.poleByJob ?? [],
    );
    const poleByJobListId = useAppSelector(
        (state: RootState) => state.pole.poleByJobListId ?? [],
    );
    const rows = useAppSelector(
        (state: RootState) => state.pole.poleByJobRows ?? 0,
    );
    const status = useAppSelector((state: RootState) => state.pole.status);
    const error = useAppSelector(
        (state: RootState) => state.pole.error ?? ({} as HttpClientError),
    );
    const poleStatusList = useAppSelector(
        (state: RootState) => state.poleStatus.list ?? [],
    );
    const singleJobState = useAppSelector(
        (state: RootState) => state.job.single ?? ({} as Job),
    );

    const { selected, change, clear } = useSelected([] as Array<string>);
    const onChange = useShiftSelected(initialPoleIds, change);

    useEffect(() => {
        dispatch(getList({ skip: 0, take: 500 }));
        dispatch(getPoleStatusList({ skip: 0, take: 500 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchSummary = () => {
        if (id && user?.id) {
            PoleApi.getPoleSummary(id as string, user.id)
                .then((res) => {
                    if (res.data) {
                        setSummaryData({
                            totalPole: res.data.totalPole || 0,
                            poleA: res.data.poleA || 0,
                            poleB: res.data.poleB || 0,
                            poleC: res.data.poleC || 0,
                        });
                    }
                })
                .catch((err) =>
                    console.error('Failed to fetch pole summary', err),
                );
        }
    };

    useEffect(() => {
        fetchSummary();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, user?.id]);

    useEffect(() => {
        if (id && id !== '') {
            dispatch(
                getPoleByJob({
                    job_id: id as string,
                    skip: 0,
                    take: 10,
                    column: 5,
                    sort: SortingEnum.Ascending,
                    no: searchQuery,
                }),
            );
            dispatch(getSingle(id as string));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (!isArrayEmpty(pole)) {
            let dataForSort = [...pole];
            setInitialPoleIds(pole.map((item) => item.id ?? ''));
            // let sortedPole = dataForSort.sort((a, b) => b.no?.localeCompare(a.no ?? '') ?? 0);
            if (isAddNewActive) {
                let data = dataForSort;
                data.unshift({
                    id: '',
                    job_id: id as string,
                    seq: '',
                    no: '',
                    address: '',
                    is_pip: false,
                    latitude: 0,
                    longitude: 0,
                    type_id: '',
                    is_fielding: true,
                    is_mre: false,
                    is_katapult: false,
                    notes: '',
                    job_number_job: '',
                    pole_type_name: '',
                    status_id: '',
                    pole_status_name: '',
                    index: 0,
                });
                setRowData(data);
            } else {
                setRowData(dataForSort);
            }
        } else {
            setRowData([]);
        }

        if (isAddNewActive && isArrayEmpty(pole)) {
            let data = [];
            data.unshift({
                id: '',
                job_id: id as string,
                seq: '',
                no: '',
                address: '',
                is_pip: false,
                latitude: 0,
                longitude: 0,
                type_id: '',
                is_fielding: true,
                is_mre: false,
                is_katapult: false,
                notes: '',
                job_number_job: '',
                pole_type_name: '',
                status_id: '',
                pole_status_name: '',
                index: 0,
            });
            setRowData(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pole, isAddNewActive]);

    useEffect(() => {
        if (
            !isSettingBatchAddress &&
            status !== undefined &&
            status !== RequestStatus.pending
        ) {
            MySwal.fire(
                savedStatusOption(
                    status === RequestStatus.success,
                    error.data?.message,
                ),
            ).then(() => {
                setIsAddNewActive(false);
                setIsRowCreate(false);
                dispatch(
                    getPoleByJob({
                        job_id: id as string,
                        skip: 0,
                        take: rowsPerPage,
                        column: 5,
                        sort: SortingEnum.Ascending,
                        no: searchQuery,
                    }),
                );
                dispatch(reset());
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error, isSettingBatchAddress]);

    const onDeleteClicked = (id: string) => {
        MySwal.fire(deletedWarnOption).then((result) => {
            if (result.isConfirmed) {
                dispatch(deletePole(id));
            }
        });
    };

    const [isRowEdit, setIsRowEdit] = useState('');
    const [isRowCreate, setIsRowCreate] = useState<boolean>(false);
    const [currentPosition, setCurrentPosition] = useState({
        rowIndex: 0,
        columnId: 0,
    });
    const [defaultCoordinate, setDefaultCoordinate] =
        useState<LocationCoordinate>({ lat: 43.45, lng: -80.49 });

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
    };

    const onPageCountChange = (pageCount: number) => {
        setPageCount(pageCount);
    };

    const openMapModal = (
        rowIndex: number,
        columnId: number,
        data: Pole,
        isEditable: boolean,
    ) => {
        console.log(isEditable);
        const filteredPole = pole.filter(
            (item) => item.latitude !== 0 && item.longitude !== 0,
        );
        const currentPole =
            pole.find((item) => item.id === data.id) ?? ({} as Pole);
        if (
            currentPole.latitude === 0 &&
            currentPole.longitude === 0 &&
            !isArrayEmpty(filteredPole)
        ) {
            setDefaultCoordinate({
                lat: filteredPole[filteredPole.length - 1].latitude ?? 43.45,
                lng: filteredPole[filteredPole.length - 1].longitude ?? -80.49,
            });
        } else {
            setDefaultCoordinate({
                lat: data.latitude ?? 43.45,
                lng: data.longitude ?? -80.49,
            });
        }
        if (isEditable) {
            setIsRowEdit(rowIndex.toString());
        }
        setShowModal(true);
        setCurrentPosition({ rowIndex, columnId });
        setIsMapEditable(isEditable);
    };

    const onAddRowClick = () => {
        setIsAddNewActive(true);
        setIsRowEdit('0');
        setIsRowCreate(true);
        setPageCount(1);
        dispatch(
            getPoleByJob({
                job_id: id as string,
                skip: 0,
                take: rowsPerPage,
                column: 5,
                sort: SortingEnum.Ascending,
                no: searchQuery,
            }),
        );
    };
    const onEditClick = (index: number) => {
        setIsRowEdit(index.toString());
        setIsRowCreate(false);
    };
    const onSaveClick = (data: Pole) => {
        let _input = {
            job_id: data.job_id,
            seq: data.seq ?? '',
            no: data.no,
            address: data.address,
            is_pip: data.is_pip ?? 0,
            latitude: data.latitude,
            longitude: data.longitude,
            type_id: data.type_id,
            is_fielding: data.is_fielding,
            is_mre: data.is_mre,
            is_katapult: data.is_katapult,
            notes: data.notes,
            index: data.index ?? 0,
        };
        if (isRowCreate) {
            dispatch(createPole(_input));
        } else {
            let sendData = {
                ..._input,
                id: data.id,
                employee_prep_id: data.employee_prep_id ?? '',
                employee_calcspec_id: data.employee_calcspec_id ?? '',
                employee_qc_id: data.employee_qc_id ?? '',
                employee_katapult_id: data.employee_katapult_id ?? '',
            };
            dispatch(updatePole(sendData));
        }
        setIsAddNewActive(false);
        setIsRowEdit('');
    };
    const onCancelClick = () => {
        setIsRowEdit('');
        setIsAddNewActive(false);
        setIsRowCreate(false);
        dispatch(
            getPoleByJob({
                job_id: id as string,
                skip: 0,
                take: rowsPerPage,
                column: 5,
                sort: SortingEnum.Ascending,
                no: searchQuery,
            }),
        );
    };

    // const toggleSelection = (key: string, employeeId: string) => {
    //     if (employeeId !== user.user_id) return null;
    //     // start off with the existing state
    //     let _selection = [...selection];
    //     const keyIndex = selection.indexOf(key);
    //     // check to see if the key exists
    //     if (keyIndex >= 0) {
    //         // it does exist so we will remove it using destructing
    //         _selection = [
    //             ...selection.slice(0, keyIndex),
    //             ...selection.slice(keyIndex + 1),
    //         ];
    //     } else {
    //         // it does not exist so add it
    //         _selection.push(key);
    //     }
    //     // update the state
    //     setSelection(_selection);
    // };

    const toggleAll = () => {
        const _selectAll = !selectAll;
        if (_selectAll) {
            change(true, poleByJobListId);
        } else {
            clear();
        }
        setSelectAll(_selectAll);
    };

    // const isSelected = (key: string) => {
    //     return selection.includes(key);
    // };

    const columns = [
        {
            Header: <></>,
            accessor: 'id',
            Cell: ({ row }: any) => {
                return (
                    <div>
                        <Checkbox
                            id={row.id}
                            onChange={(event) =>
                                onChange(event, row.original.id)
                            }
                            checked={selected.includes(row.original.id)}
                            className="w-5 h-5 rounded text-[#308c69] focus:ring-[#308c69]"
                        />
                    </div>
                );
            },
        },
        {
            Header: 'NO.',
            accessor: 'index',
            Cell: (props: any) =>
                EditableCell({ ...props, textType: 'number' }),
            // Cell: ({row: {index}}: any) => {
            //     return <div>{index + 1}</div>;
            // },
        },
        {
            Header: 'Pole Seq',
            minWidth: 150,
            accessor: 'seq',
            Cell: EditableCell,
        },
        {
            Header: 'Pole No',
            minWidth: 150,
            accessor: 'no',
            Cell: EditableCell,
        },
        {
            Header: 'Pole Address',
            minWidth: 150,
            accessor: 'address',
            Cell: EditableCell,
        },
        {
            Header: 'PIP',
            minWidth: 150,
            accessor: 'is_pip',
            Cell: ({
                value: initialValue,
                row: { index },
                column: { id },
            }: any) => {
                return (
                    <>
                        {isRowEdit === index.toString() ? (
                            <Checkbox
                                id="is_pip"
                                checked={initialValue}
                                onChange={(e) => onCheckboxChange(e, index, id)}
                            />
                        ) : (
                            <>{initialValue ? 'True' : 'False'}</>
                        )}
                    </>
                );
            },
        },
        {
            Header: 'Latitude',
            minWidth: 150,
            accessor: 'latitude',
            Cell: EditableCell,
        },
        {
            Header: 'Longitude',
            minWidth: 150,
            accessor: 'longitude',
            Cell: EditableCell,
        },
        {
            Header: 'Pole Type',
            minWidth: 150,
            accessor: 'type_name',
            Cell: ({
                value: initialValue,
                row: { index },
                column: { id },
            }: any) => {
                return (
                    <>
                        {isRowEdit === index.toString() ? (
                            <SelectInput
                                key={`my_unique_select_key__${initialValue}`}
                                options={poleTypeOptions}
                                // isLoading={isProjectLoading}
                                // label="Project"
                                onChange={(val: SingleValue<Option>) =>
                                    onPoleTypeChange(val, index, id)
                                }
                                // message={errors.project_id?.message}
                                defaultInputValue={initialValue}
                                menuPosition="fixed"
                                menuPlacement="auto"
                            />
                        ) : (
                            <span className="text-sm font-normal">
                                {initialValue}
                            </span>
                        )}
                    </>
                );
            },
        },
        {
            Header: 'Fielding',
            minWidth: 150,
            accessor: 'is_fielding',
            Cell: ({
                value: initialValue,
                row: { index },
                column: { id },
            }: any) => {
                return (
                    <>
                        {isRowEdit === index.toString() ? (
                            <Checkbox
                                id="is_fielding"
                                checked={initialValue}
                                onChange={(e) => onCheckboxChange(e, index, id)}
                            />
                        ) : (
                            <>{initialValue ? 'True' : 'False'}</>
                        )}
                    </>
                );
            },
        },
        {
            Header: 'MRE',
            minWidth: 150,
            accessor: 'is_mre',
            Cell: ({ value: initialValue, row: { index } }: any) => {
                return (
                    <>
                        {isRowEdit === index.toString() ? (
                            <></>
                        ) : (
                            // <Checkbox
                            //     id="is_mre"
                            //     checked={initialValue}
                            //     onChange={(e) => onCheckboxChange(e, index, id)}
                            // />
                            <>{initialValue ? 'True' : 'False'}</>
                        )}
                    </>
                );
            },
        },
        {
            Header: 'Katapult',
            minWidth: 150,
            accessor: 'is_katapult',
            Cell: ({ value: initialValue, row: { index } }: any) => {
                return (
                    <>
                        {isRowEdit === index.toString() ? (
                            <></>
                        ) : (
                            // <Checkbox
                            //     id="is_katapult"
                            //     checked={initialValue}
                            //     onChange={(e) => onCheckboxChange(e, index, id)}
                            // />
                            <>{initialValue ? 'True' : 'False'}</>
                        )}
                    </>
                );
            },
        },
        {
            Header: 'Notes Fielding',
            minWidth: 150,
            accessor: 'notes',
            Cell: EditableCell,
        },
        {
            Header: 'Pole Status',
            minWidth: 150,
            accessor: 'status_name',
        },
        {
            Header: 'Job Prep',
            minWidth: 150,
            accessor: 'employee_prep_name',
        },
        {
            Header: 'Action',
            minWidth: 150,
            sticky: 'right',
            Cell: ({ row, column: { id } }: any) => {
                return (
                    <>
                        {!isRowEdit && (
                            <>
                                <button
                                    onClick={() =>
                                        openMapModal(
                                            row?.index,
                                            id,
                                            row.original,
                                            user.user_id ===
                                                row?.original
                                                    ?.employee_prep_id &&
                                                checkRoleActionAccess(
                                                    user?.roleName,
                                                    MenuEnum.WorksheetJobPrep,
                                                    ActionEnum.PinMapPole,
                                                ),
                                        )
                                    }
                                >
                                    <FaMapMarkerAlt className="mr-2 text-2xl text-primary-color" />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handleSetPoleAddress(row)}
                                    className="bg-[#308c69] hover:bg-[#267356] text-white px-2 py-1 rounded text-xs transition-colors shadow-sm cursor-pointer mr-2 whitespace-nowrap"
                                    disabled={!isLoaded}
                                    title="Set Pole Address"
                                >
                                    Set Address
                                </button>
                            </>
                        )}
                        {(row?.original?.id === '' ||
                            user.user_id ===
                                row?.original?.employee_prep_id) && (
                            <>
                                {isRowEdit === row?.index.toString() ? (
                                    <>
                                        {checkRoleActionAccess(
                                            user?.roleName,
                                            MenuEnum.WorksheetJobPrep,
                                            ActionEnum.PinMapPole,
                                        ) && (
                                            <button
                                                onClick={() =>
                                                    openMapModal(
                                                        row?.index,
                                                        id,
                                                        row.original,
                                                        true,
                                                    )
                                                }
                                            >
                                                <FaMapMarkerAlt className="mr-2 text-2xl text-primary-color" />
                                            </button>
                                        )}
                                        <button
                                            onClick={() =>
                                                onSaveClick(row.original)
                                            }
                                        >
                                            <BiCheckCircle className="mr-2 text-2xl text-primary-color" />
                                        </button>
                                        <button onClick={() => onCancelClick()}>
                                            <MdOutlineCancel className="mr-2 text-2xl text-secondary-color" />
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        {checkRoleActionAccess(
                                            user?.roleName,
                                            MenuEnum.WorksheetJobPrep,
                                            ActionEnum.Edit,
                                        ) && (
                                            <button
                                                onClick={() =>
                                                    onEditClick(row?.index)
                                                }
                                            >
                                                <BiEditAlt className="mr-2 text-2xl text-primary-color" />
                                            </button>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                        {(row?.original?.id === '' ||
                            user.user_id === row?.original?.employee_prep_id ||
                            user?.roleName.some(
                                (item) => item === 'Job Prep',
                            )) && (
                            <button
                                onClick={() => onDeleteClicked(row.original.id)}
                            >
                                <MdOutlineDeleteForever className="mr-2 text-2xl text-secondary-color" />
                            </button>
                        )}
                    </>
                );
            },
        },
    ];

    const onCheckboxChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        rowIndex: any,
        columnId: any,
    ) => {
        setRowData((old) =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: e.target.checked,
                    };
                }
                return row;
            }),
        );
    };

    const updateMyData = (rowIndex: number, columnId: any, value: any) => {
        // We also turn on the flag to not reset the page
        setRowData((old) =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    };
                }
                return row;
            }),
        );
    };

    // FIXME: simplify this into one function
    const onPoleTypeChange = (
        val: SingleValue<Option>,
        rowIndex: any,
        columnId: any,
    ) => {
        setRowData((old) =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        type_id: val?.value ?? '',
                        [columnId]: val?.text ?? '',
                    };
                }
                return row;
            }),
        );
    };

    const onCoordinateChange = (
        coordinate: LocationCoordinate | undefined,
        address: string,
    ) => {
        // We also turn on the flag to not reset the page
        setRowData((old) =>
            old.map((row, index) => {
                if (index === currentPosition.rowIndex) {
                    return {
                        ...old[currentPosition.rowIndex],
                        latitude: coordinate !== undefined ? coordinate.lat : 0,
                        longitude:
                            coordinate !== undefined ? coordinate.lng : 0,
                        address: address,
                    };
                }
                return row;
            }),
        );
        setShowModal(false);
    };

    // FIXME: end of simplify this into one function

    const allSelectedIds = useMemo(() => {
        return selected.filter(Boolean);
    }, [selected]);

    const handleClearSelection = () => {
        setSelectAll(false);
        clear();
    };

    const onMultipleDelete = () => {
        if (isArrayEmpty(allSelectedIds)) return null;
        let poleIds = allSelectedIds.toString();
        MySwal.fire(
            customWarnOption(
                'Delete Multiple Data',
                'Are you sure you want to delete the selected items?',
            ),
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteMultiplePole(poleIds));
                handleClearSelection();
            }
        });
    };

    const onMultipleChangeStatus = (status: string) => {
        if (isArrayEmpty(allSelectedIds)) return null;
        let poleIds = allSelectedIds.toString();
        MySwal.fire(
            customWarnOption(
                'Change Status Multiple Data',
                'Are you sure you want to change status the selected items?',
            ),
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    changeStatusMultiplePole({
                        pole_ids: poleIds,
                        status_id: status,
                    }),
                );
                handleClearSelection();
            }
        });
    };

    const filteredData = useMemo(() => {
        return rowData.filter((item) => {
            if (item.id === '') return true;

            if (searchQuery.trim()) {
                const q = searchQuery.toLowerCase().trim();
                const matchNo = item.no
                    ? item.no.toLowerCase().includes(q)
                    : false;
                const matchSeq = item.seq
                    ? item.seq.toLowerCase().includes(q)
                    : false;
                const matchType = item.pole_type_name
                    ? item.pole_type_name.toLowerCase().includes(q)
                    : item.type_name
                      ? item.type_name.toLowerCase().includes(q)
                      : false;
                const matchNotes = item.notes
                    ? item.notes.toLowerCase().includes(q)
                    : false;
                const matchStatus = item.pole_status_name
                    ? item.pole_status_name.toLowerCase().includes(q)
                    : false;
                if (
                    !matchNo &&
                    !matchSeq &&
                    !matchType &&
                    !matchNotes &&
                    !matchStatus
                ) {
                    return false;
                }
            }

            return true;
        });
    }, [rowData, searchQuery]);

    const handleSearch = () => {
        if (id && id !== '') {
            dispatch(
                getPoleByJob({
                    job_id: id as string,
                    skip: 0,
                    take: rowsPerPage,
                    column: 5,
                    sort: SortingEnum.Ascending,
                    no: searchQuery,
                }),
            );
            setPageCount(1);
        }
    };

    const handleExportKML = async () => {
        setIsExportingKML(true);
        try {
            const res = await PoleApi.getPoleByJob(
                {
                    job_id: id as string,
                    skip: 0,
                    take: rows > 0 ? rows : 10000,
                    column: 5,
                    sort: SortingEnum.Ascending,
                    no: searchQuery,
                },
                user?.id || '',
            );

            const allExportData = res.data || [];

            if (isArrayEmpty(allExportData)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'No Data',
                    text: 'There are no poles to export.',
                });
                return;
            }

            let kmlContent = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>Pole Export - ${singleJobState.number_job || id}</name>`;

            allExportData.forEach((data: Pole) => {
                if (data.latitude && data.longitude) {
                    let descriptionContent = '';
                    descriptionContent += `          <b>Job Number:</b> ${data.job_number_job || ''}<br/>\n`;
                    descriptionContent += `          <b>Pole Seq:</b> ${data.seq || ''}<br/>\n`;
                    descriptionContent += `          <b>Pole No:</b> ${data.no || data.seq || ''}<br/>\n`;
                    descriptionContent += `          <b>Is Pip:</b> ${data.is_pip}<br/>\n`;
                    descriptionContent += `          <b>Pole Type:</b> ${data.pole_type_name || ''}<br/>\n`;
                    descriptionContent += `          <b>Pole Status:</b> ${data.pole_status_name || ''}<br/>\n`;

                    kmlContent += `
    <Placemark>
      <name>${data.no || data.seq || 'Unknown'}</name>
      <description>
        <![CDATA[
${descriptionContent}        ]]>
      </description>
      <Point>
        <coordinates>${data.longitude},${data.latitude},0</coordinates>
      </Point>
    </Placemark>`;
                }
            });

            kmlContent += `
  </Document>
</kml>`;

            const kmlBlob = new Blob([kmlContent], {
                type: 'application/vnd.google-earth.kml+xml',
            });
            const url = URL.createObjectURL(kmlBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Pole_Export_${singleJobState.number_job || id}_${Date.now()}.kml`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Export KML failed', error);
            Swal.fire({
                icon: 'error',
                title: 'Export Failed',
                text: 'Terjadi kesalahan saat melakukan export KML.',
            });
        } finally {
            setIsExportingKML(false);
        }
    };

    const handleExportSelectedToExcel = () => {
        if (isArrayEmpty(allSelectedIds)) return;

        const selectedPoles = rowData.filter((pole) =>
            allSelectedIds.includes(pole.id),
        );

        const excelData = selectedPoles.map((data, index) => ({
            'NO.': data.index ?? index + 1,
            'Pole Seq': data.seq,
            'Pole No': data.no,
            'Pole Address': data.address,
            PIP: data.is_pip ? 'True' : 'False',
            Latitude: data.latitude,
            Longitude: data.longitude,
            'Pole Type': data.pole_type_name || data.type_name,
            Fielding: data.is_fielding ? 'True' : 'False',
            MRE: data.is_mre ? 'True' : 'False',
            Katapult: data.is_katapult ? 'True' : 'False',
            'Notes Fielding': data.notes,
            'Pole Status': (data as any).status_name || data.pole_status_name,
            'Job Prep': (data as any).employee_prep_name,
        }));

        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Selected Poles');
        XLSX.writeFile(
            wb,
            `Selected_Poles_${singleJobState.number_job || id}_${moment().format('YYYYMMDD_HHmmss')}.xlsx`,
        );
    };

    const handleRefresh = () => {
        dispatch(
            getPoleByJob({
                job_id: id as string,
                skip: rowsPerPage * (pageCount - 1),
                take: rowsPerPage,
                column: 5,
                sort: SortingEnum.Ascending,
                no: searchQuery,
            }),
        );
        fetchSummary();
    };

    const handlePageChange = (page: number) => {
        setIsRowEdit('');
        setIsAddNewActive(false);
        dispatch(
            getPoleByJob({
                job_id: id as string,
                skip: rowsPerPage * (page - 1),
                take: rowsPerPage,
                column: 5,
                sort: SortingEnum.Ascending,
                no: searchQuery,
            }),
        );
    };

    const handleRowChange = (totalRow: number) => {
        setRowsPerPage(totalRow);
        dispatch(
            getPoleByJob({
                job_id: id as string,
                skip: 0,
                take: totalRow,
                column: 5,
                sort: SortingEnum.Ascending,
                no: searchQuery,
            }),
        );
    };

    // Original local computations are removed in favor of API summary
    const lastUpdatedFormatted = singleJobState.ts_created
        ? moment(singleJobState.ts_created).format('D MMM YYYY, h:mm A')
        : '2 Aug 2025, 10:45 AM';
    const lastUpdatedBy =
        singleJobState.department_owner_name || user?.username || 'RBU';

    const projectDisplay = singleJobState.project_name
        ? singleJobState.project_name
        : singleJobState.number_id
          ? `${singleJobState.number_id}`
          : '';
    const jobDisplay = singleJobState.number_job
        ? singleJobState.number_job
        : '';
    const headerTitle = `Job Prep (${singleJobState.number_id || ''} / ${singleJobState.number_job || ''})`;

    return (
        <div>
            {/* Top Header Row */}
            <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
                <h1 className="text-lg font-bold text-gray-800 dark:text-gray-100 truncate mr-3">
                    {headerTitle}
                </h1>
                <div className="flex items-center gap-2">
                    {checkRoleActionAccess(
                        user?.roleName,
                        MenuEnum.WorksheetJobPrep,
                        ActionEnum.Input,
                    ) && (
                        <button
                            type="button"
                            onClick={onAddRowClick}
                            disabled={isAddNewActive}
                            className="bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-750 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 px-4 py-2 rounded-lg text-xs sm:text-sm font-medium shadow-2xs transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Add New Pole
                        </button>
                    )}
                    <button
                        type="button"
                        onClick={() => {
                            setShowExcelPanel((prev) => !prev);
                            if (!showExcelPanel) setShowMaps(false);
                        }}
                        className="bg-[#308c69] hover:bg-[#267356] text-white px-4 py-2 rounded-lg text-xs sm:text-sm font-medium shadow-2xs transition-colors flex items-center gap-1.5 cursor-pointer"
                    >
                        <FiUpload className="text-base" />
                        <span>Upload Excel</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setShowMaps((prev) => !prev);
                            if (!showMaps) setShowExcelPanel(false);
                        }}
                        className="bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-750 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 px-4 py-2 rounded-lg text-xs sm:text-sm font-medium shadow-2xs transition-colors cursor-pointer flex items-center gap-1.5"
                    >
                        <FaMapMarkerAlt className="text-base text-red-500" />
                        <span>View Maps</span>
                    </button>
                    <button
                        type="button"
                        onClick={handleExportKML}
                        disabled={isExportingKML}
                        className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-xs sm:text-sm font-medium shadow-2xs transition-colors flex items-center gap-1.5 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isExportingKML ? (
                            <span>Exporting...</span>
                        ) : (
                            <span>Export KML</span>
                        )}
                    </button>
                    <div>
                        <Dropdown
                            color="light"
                            label={
                                <AiOutlineMenu className="text-lg text-gray-700 dark:text-gray-200" />
                            }
                            arrowIcon={false}
                        >
                            <Dropdown.Header>
                                <span className="block text-sm font-medium truncate">
                                    Multiple Action
                                </span>
                            </Dropdown.Header>
                            {checkRoleActionAccess(
                                user?.roleName,
                                MenuEnum.WorksheetJobPrep,
                                ActionEnum.ChangePoleStatus,
                            ) && (
                                <>
                                    {poleStatusList.map((status) => (
                                        <Dropdown.Item
                                            key={status.id}
                                            onClick={() =>
                                                onMultipleChangeStatus(
                                                    status.id,
                                                )
                                            }
                                        >
                                            <span
                                                className={`${isArrayEmpty(allSelectedIds) && 'text-gray-400'}`}
                                            >
                                                {status.name}
                                            </span>
                                        </Dropdown.Item>
                                    ))}
                                </>
                            )}
                            {checkRoleActionAccess(
                                user?.roleName,
                                MenuEnum.WorksheetJobPrep,
                                ActionEnum.Delete,
                            ) && (
                                <>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={onMultipleDelete}>
                                        <span
                                            className={`${isArrayEmpty(allSelectedIds) && 'text-gray-400'}`}
                                        >
                                            Delete
                                        </span>
                                    </Dropdown.Item>
                                </>
                            )}
                        </Dropdown>
                    </div>
                </div>
            </div>

            {/* Excel Upload & Template Section */}
            {showExcelPanel && (
                <JobPrepExcelPanel
                    jobId={id}
                    userName={lastUpdatedBy}
                    onImportSuccess={handleRefresh}
                />
            )}

            {/* View Maps Section */}
            {showMaps && (
                <div className="mb-6 rounded-xl overflow-hidden border border-gray-200 dark:border-gray-700 shadow-sm">
                    <ViewMaps />
                </div>
            )}

            {/* Table Toolbar: Selection Bar + Search & Filters */}
            <div className="flex flex-wrap items-center justify-between gap-3 my-4">
                {/* Left: Row Selection Actions */}
                <div className="flex items-center gap-2">
                    <Checkbox
                        id="select_all_toolbar"
                        checked={selectAll}
                        onChange={toggleAll}
                        className="w-5 h-5 rounded text-[#308c69] focus:ring-[#308c69]"
                    />
                    <span
                        className="text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mr-2 cursor-pointer"
                        onClick={toggleAll}
                    >
                        {allSelectedIds.length} rows selected
                    </span>
                    <button
                        type="button"
                        onClick={onMultipleDelete}
                        disabled={allSelectedIds.length === 0}
                        className="border border-red-500 text-red-500 hover:bg-red-50 dark:hover:bg-red-950/20 disabled:opacity-40 disabled:cursor-not-allowed font-medium text-xs sm:text-sm px-3.5 py-1.5 rounded-lg transition-colors cursor-pointer"
                    >
                        Delete Selected
                    </button>
                    <button
                        type="button"
                        onClick={handleClearSelection}
                        disabled={allSelectedIds.length === 0}
                        className="border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-750 disabled:opacity-40 disabled:cursor-not-allowed font-medium text-xs sm:text-sm px-3.5 py-1.5 rounded-lg transition-colors cursor-pointer"
                    >
                        Clear Selection
                    </button>
                    <button
                        type="button"
                        onClick={handleExportSelectedToExcel}
                        disabled={allSelectedIds.length === 0}
                        className="bg-[#308c69] hover:bg-[#267356] text-white disabled:opacity-40 disabled:cursor-not-allowed font-medium text-xs sm:text-sm px-3.5 py-1.5 rounded-lg transition-colors cursor-pointer"
                    >
                        Export Pole
                    </button>
                    <button
                        type="button"
                        onClick={handleSetMultiplePoleAddress}
                        disabled={
                            allSelectedIds.length === 0 ||
                            isSettingBatchAddress ||
                            !isLoaded
                        }
                        className="bg-[#308c69] hover:bg-[#267356] text-white disabled:opacity-40 disabled:cursor-not-allowed font-medium text-xs sm:text-sm px-3.5 py-1.5 rounded-lg transition-colors cursor-pointer"
                    >
                        {isSettingBatchAddress
                            ? 'Setting Address...'
                            : 'Set Address'}
                    </button>
                </div>

                {/* Right: Search, Filter & Refresh */}
                <div className="flex items-center gap-2">
                    {/* Search Input */}
                    <div className="relative min-w-[240px] sm:min-w-[300px]">
                        <RiSearchLine className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-base pointer-events-none" />
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch();
                                }
                            }}
                            placeholder="Search pole no..."
                            className="w-full pl-9 pr-8 py-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-xs sm:text-sm text-gray-800 dark:text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#308c69] focus:border-transparent transition-all"
                        />
                        {searchQuery && (
                            <button
                                type="button"
                                onClick={() => {
                                    setSearchQuery('');
                                    // Optionally auto-search on clear
                                    setTimeout(() => handleSearch(), 0);
                                }}
                                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 cursor-pointer"
                            >
                                <MdOutlineCancel className="text-base" />
                            </button>
                        )}
                    </div>

                    {/* Filters Button with Dropdown */}
                    <button
                        type="button"
                        onClick={handleSearch}
                        className="bg-[#308c69] hover:bg-[#267356] text-white px-4 py-1.5 rounded-lg text-xs sm:text-sm font-medium shadow-2xs transition-colors flex items-center gap-1.5 cursor-pointer"
                    >
                        <span>Search</span>
                    </button>

                    {/* Refresh Button */}
                    <button
                        type="button"
                        title="Refresh Poles"
                        onClick={handleRefresh}
                        className="p-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-750 bg-white dark:bg-gray-800 rounded-lg text-sm transition-colors cursor-pointer flex items-center justify-center shadow-2xs"
                    >
                        <FiRefreshCw className="text-sm" />
                    </button>
                </div>
            </div>

            {/* Table with Server Paging */}
            <div className="main-data-grid mt-2">
                <TableWithServerPaging
                    columns={columns}
                    data={filteredData}
                    serverRows={rows}
                    handlePageChange={handlePageChange}
                    handleRowChange={handleRowChange}
                    updateMyData={updateMyData}
                    rowEdit={isRowEdit}
                    pageCount={pageCount}
                    changePageCount={onPageCountChange}
                    selectedRowIds={allSelectedIds}
                />

                {/* Summary Cards Section */}
                <JobPrepSummaryCards summaryData={summaryData} />

                <DefaultModal
                    title="Maps"
                    show={showModal}
                    onClose={toggleModal}
                    size="7xl"
                    body={
                        <div style={{ height: '80vh', width: '100%' }}>
                            <Places
                                onCoordinateChange={onCoordinateChange}
                                defaultCoordinate={defaultCoordinate}
                                isMapEditable={isMapEditable}
                            />
                        </div>
                    }
                />
            </div>
        </div>
    );
};

export default JobPrepTable;
